import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import '../styles/teams.css';

export function TeamRequestPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [region, setRegion] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    setSuccess(null);
    try {
      const team = await api.createTeam({ name, description, region });
      setSuccess(
        team.status === 'active'
          ? 'Team created and active.'
          : 'Request submitted. An admin will approve it shortly.'
      );
      setName('');
      setDescription('');
      setRegion('');
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="teams-page">
      <div className="teams-page__header">
        <div>
          <h1>Request a team</h1>
          <p className="hint">
            Submit a new team for scoped visibility. Admins can approve it; creators become team admins on activation.
          </p>
        </div>
        <button className="button button-secondary" onClick={() => navigate('/teams')}>
          Back to teams
        </button>
      </div>

      {error ? <div className="alert alert-error">{error}</div> : null}
      {success ? <div className="alert alert-success">{success}</div> : null}

      <form className="form card card-subtle" onSubmit={handleSubmit}>
        <div className="form-row">
          <label htmlFor="team-name">Team name</label>
          <input
            id="team-name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            required
          />
        </div>

        <div className="form-row">
          <label htmlFor="team-description">
            Description <span className="label-optional">(optional)</span>
          </label>
          <textarea
            id="team-description"
            rows={3}
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            placeholder="Who is this team for and when should it be used?"
          />
        </div>

        <div className="form-row">
          <label htmlFor="team-region">
            Region <span className="label-optional">(optional)</span>
          </label>
          <input
            id="team-region"
            value={region}
            onChange={(event) => setRegion(event.target.value)}
            placeholder="e.g. EU, US, Global"
          />
        </div>

        <div className="form-row">
          <button className="button" type="submit" disabled={submitting}>
            {submitting ? 'Submitting…' : 'Submit request'}
          </button>
        </div>
      </form>
    </div>
  );
}
